import React from 'react';
import '../../styles.scss'
import axios from 'axios'
import {Link} from "react-router-dom";
import { useEffect } from 'react';
import { useState } from 'react';

const Catalog = (props) => {
    const [books, setBooks] = useState([])
    useEffect(()=>{
        axios.get('http://kitap.alsu.tatar/api/tale/list').then((response)=>{
            console.log(response.data);
            setBooks(response.data.message)
        })
    }, [])
    return (
       <div className={'column'}>
        <img src={require('../../assets/lDecor.png')} width={150} style={{position: 'fixed', bottom: 0, left: 0}} />
        <img src={require('../../assets/rDecor.png')} width={150} style={{position: 'fixed', top: 30, right: 0}} />

           <div className={'catalog-page-text-container'}>
            <p className='heading text__white' style={{textAlign:  'center'}}>ТЫЛСЫМЛЫ КИТАП</p>
               <span className={'regular-text-400 text__white '}>
                   Тылсымлы китап – битләрен ачып уку мөмкинлеге булган интерактив әсбап ул. Әлеге китап тавышландырылган. Димәк, аны тыңлау мөмкинлеге дә бар. Китаптагы рәсемнәрне зурайтып карарга була. Ә китерелгән видеоөзекләр китап белән танышуны тагын да мавыктыргычрак итәр.
               </span>
           </div>
           <div className={'row row-wrap justify-center'}>
                {books.map(book=>(
                     <Link to={{pathname: '/tales/'+book._id, query: {book}}} className={'mr-7 mb-3'} >
                     <img className={'cover'} src={'http://kitap.alsu.tatar'+book.cover} />
                 </Link>
                ))}

           </div>
       </div>
    )
};

export default Catalog;
